module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/roof-4229ae1f9ae3334c11d0927343e08de3.jpg";